import {DOM,inject,containerless} from "aurelia-framework";
import {EventAggregator, Subscription} from "aurelia-event-aggregator";

@containerless()
@inject(EventAggregator)
export class SearchViewHeader {

  subscriber: Subscription;
  mask: any;

  constructor(private _ea: EventAggregator) {
  }

  attached(){
    this.subscriber = this._ea.subscribe('DSSB:newGlobalSearch', msg => this.setMask(msg.value));
    this._ea.publish('DSSB:newGlobalSearch',{value:DOM.getElementById('header-search') ? (DOM.getElementById('header-search') as HTMLInputElement).value : ''});
  }
  detaches(){
    this.subscriber.dispose();
  }
  setMask(value){
    this.mask = value;
  }

}
